import { Directive } from '@angular/core';


export class TooltipContainerDirective { }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/shared/components/tooltip/tooltip-container.directive.ts